export const SHIPPED_SHIELD_SKU = 'WORRY_FREE_DELIVERY'
